/* DC Motion — mouvement sobre sur tout le site.

   REGLE : on anime ce qui RACONTE, jamais ce qui VEND.
   ⚠ Grilles produits non animees (images differees + pagination infinie).
   ⚠ En-tetes de page : on anime le CONTENEUR, jamais ses enfants (conflit d'opacite).
   ⚠ Zone d'achat des fiches produit intouchable.

   CASCADE : un bloc « raconte » quand ses ELEMENTS arrivent l'un apres l'autre. Un bloc
   revele d'un seul tenant parait fige a cote des autres — c'est pourquoi les bandes
   marque (accueil + boutique) passent par GROUPES et non par SOLOS.
   ⚠ Ne jamais marquer un parent ET ses enfants : les opacites se multiplient.

   ⚠ LE FILET REVELE AUSSI CE QUI EST DEJA PASSE
   Bug constate en mobile : en defilement rapide, les blocs de confiance de l'accueil
   restaient INVISIBLES apres avoir ete depasses — un vide blanc a la place du texte.
   L'observer peut manquer un element si le defilement le traverse entre deux images, et
   l'ancien filet ne rattrapait que ce qui etait A L'ECRAN. Un element deja depasse n'a
   aucune raison de rester cache : on le revele aussi. L'effet est intact (ce qui est
   sous la ligne de flottaison s'anime toujours a l'arrivee), le contenu ne peut plus
   disparaitre. Ne jamais revenir a un filet « a l'ecran seulement ». */
(function () {
  if (window.__dcMotion) return;
  window.__dcMotion = 1;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var html = document.documentElement;

  /* ---------- Hero d'accueil : cascade immediate ---------- */
  var hero = document.querySelector('.dc-hero');
  var heroKids = hero ? hero.querySelectorAll('.dc-hero__in > *') : [];
  if (heroKids.length) {
    html.classList.add('dc-motion');
    for (var k = 0; k < heroKids.length; k++) heroKids[k].style.setProperty('--dcm-d', (k * 85) + 'ms');
    var lance = function () { hero.classList.add('is-in'); };
    requestAnimationFrame(function () { requestAnimationFrame(lance); });
    setTimeout(lance, 1200);
    window.addEventListener('pageshow', lance);
  }

  /* ---------- Groupes : les enfants arrivent en cascade ---------- */
  var GROUPES = [
    ['.dc-sec .dc-head', ':scope > *'],
    ['.dc-sec .dc-bento', ':scope > .dc-tile'],
    ['.dc-sec .dc-prods', ':scope > .dc-prod'],
    ['.dc-sec .dc-split', ':scope > *'],
    ['.dc-sec .dc-trust', ':scope > *'],
    ['.dc-sec .dc-cta', ':scope > *'],
    ['.dc-shop__grid', ':scope > .dc-shop__c'],
    ['.dcpd__in', ':scope > *'],
    ['.dcpc__w', ':scope > *'],
    ['.dcpc__card', ':scope > *'],
    /* bandes marque : meme traitement que les autres blocs du site */
    ['.dct__w > div:first-child', ':scope > *'],
    ['.dcbt__in', ':scope > .dcbt__l > *, :scope > .dcbt__go']
  ];

  /* ---------- Solos : un bloc, un revele ---------- */
  var SOLOS = ['.dcsh__in', '.dcph__in', '.dcsf__in'];

  function interdit(el) {
    return el.closest(
      '.dc-hero, .dc-mq, header, .dcf, .dcw, .shopify-section-group-header-group, ' +
      'product-information, .product-information, .sticky-add-to-cart, .dc-ups, ' +
      '.product-grid, [class*="resource-list"]'
    ) !== null;
  }

  var cibles = [], obs = null;
  function marquer(el, type, retard) {
    if (!el || el.hasAttribute('data-dcm') || interdit(el)) return;
    if (el.getBoundingClientRect().height < 12) return;
    el.setAttribute('data-dcm', type);
    if (retard) el.style.setProperty('--dcm-d', retard + 'ms');
    cibles.push(el);
    if (obs) obs.observe(el);
  }

  function balayer() {
    GROUPES.forEach(function (g) {
      document.querySelectorAll(g[0]).forEach(function (p) {
        if (interdit(p)) return;
        var enfants = p.querySelectorAll(g[1]);
        var i = 0;
        enfants.forEach(function (e) {
          marquer(e, enfants.length > 3 ? 'g' : 'b', Math.min(i * 70, 280));
          i++;
        });
      });
    });
    SOLOS.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (e) { marquer(e, 'b', 0); });
    });
  }
  balayer();

  document.querySelectorAll('.dc-tile, .dc-prod, #MainContent .product-card').forEach(function (c) {
    c.classList.add('dc-hov');
  });

  html.classList.add('dc-motion');

  function reveler(el) { el.classList.add('is-in'); if (obs) obs.unobserve(el); }

  obs = new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) { if (e.isIntersecting) reveler(e.target); });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
  cibles.forEach(function (c) { obs.observe(c); });

  /* blocs injectes par JS (bande marque de la boutique) */
  try {
    new MutationObserver(function () { balayer(); })
      .observe(document.body, { childList: true, subtree: true });
  } catch (e) {}

  /* filet : a l'ecran OU deja depasse (voir l'avertissement en tete de fichier) */
  function secours() {
    var h = window.innerHeight;
    for (var i = cibles.length - 1; i >= 0; i--) {
      var c = cibles[i];
      if (c.classList.contains('is-in')) { cibles.splice(i, 1); continue; }
      var r = c.getBoundingClientRect();
      if (r.top < h) reveler(c);
    }
  }
  requestAnimationFrame(secours);
  [400, 1200, 2500].forEach(function (t) { setTimeout(secours, t); });

  var tick = false;
  window.addEventListener('scroll', function () {
    if (tick) return;
    tick = true;
    requestAnimationFrame(function () { tick = false; secours(); });
  }, { passive: true });
})();
